import mapFunction from './mapResources';

export default mapFunction('unlocked_employees', {
    isFetching: false,
    items: [] 
});